// assets/byRavn-promo-countdown.js
// Live promo countdown for the announcement bar. The deadline is resolved to an absolute,
// offset-bearing instant server-side, so the browser only parses and ticks — no timezone math.
(function () {
  var SEL = '[data-brv-countdown]';
  var timer = null;

  function nodes() {
    return document.querySelectorAll(SEL);
  }

  function unit(el, key, fallback) {
    var value = el.getAttribute('data-unit-' + key);
    if (!value || value.indexOf('translation missing') !== -1) return fallback;
    return value;
  }

  function plural(n, singular, plural) {
    return n === 1 ? singular : plural;
  }

  function hideBlock(el) {
    var wrap = el.closest('[data-brv-countdown-wrap]');
    if (!wrap) return;
    wrap.style.display = 'none';
    var divider = wrap.nextElementSibling;
    if (divider && divider.classList.contains('announcement-bar__divider')) {
      divider.style.display = 'none';
    }
  }

  function start() {
    var first = nodes()[0];
    if (!first) return;

    var deadlineMs = Date.parse(first.getAttribute('data-deadline'));
    var L = {
      day: unit(first, 'day', 'day'),
      days: unit(first, 'days', 'days'),
      hour: unit(first, 'hour', 'hour'),
      hours: unit(first, 'hours', 'hours'),
      minute: unit(first, 'minute', 'minute'),
      minutes: unit(first, 'minutes', 'minutes'),
      and: unit(first, 'and', 'and')
    };

    function paint() {
      var list = nodes();
      if (!list.length) return;

      var diff = deadlineMs - Date.now();
      if (isNaN(deadlineMs) || diff <= 0) {
        var bar = list[0].closest('.announcement-bar');
        if (bar && bar.hasAttribute('data-hide-on-expiry')) {
          var section = bar.closest('.shopify-section') || bar;
          section.style.display = 'none';
        } else {
          for (var i = 0; i < list.length; i++) {
            var el = list[i];
            var expired = el.getAttribute('data-expired-text');
            if (expired) {
              var wrap = el.closest('[data-brv-countdown-wrap]') || el;
              wrap.textContent = expired;
            } else {
              hideBlock(el);
            }
          }
        }
        clearInterval(timer);
        timer = null;
        return;
      }

      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var text =
        days + ' ' + plural(days, L.day, L.days) + ', ' +
        hours + ' ' + plural(hours, L.hour, L.hours) + ' ' + L.and + ' ' +
        minutes + ' ' + plural(minutes, L.minute, L.minutes) + '.';

      for (var j = 0; j < list.length; j++) list[j].textContent = text;
    }

    clearInterval(timer);
    paint();
    timer = setInterval(paint, 1000);
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(start);
  document.addEventListener('shopify:section:load', start);
})();
